// CLU debug logging gate (performance plan P4).
// Hot-path console logging (per-SSE-event, per-apiCall) is gated behind a
// switchable flag so end users pay zero logging cost by default, while the
// logs remain one flag away for debugging sessions.
//
// Enable from the browser console:  cluDebug.enable()
// Disable:                          cluDebug.disable()
// Both take effect immediately (no reload) and persist via localStorage.

const STORAGE_KEY = 'clu_debug';

function readFlagFromStorage(): boolean {
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

let enabled = readFlagFromStorage();

export function isCluDebugEnabled(): boolean {
  return enabled;
}

export function enableCluDebug(): void {
  enabled = true;
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // localStorage unavailable (private mode, etc.) — in-memory flag still applies
  }
}

export function disableCluDebug(): void {
  enabled = false;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // localStorage unavailable — in-memory flag still applies
  }
}

export function debugLog(...args: unknown[]): void {
  if (enabled) console.log(...args);
}

export function debugDebug(...args: unknown[]): void {
  if (enabled) console.debug(...args);
}

if (typeof window !== 'undefined') {
  (window as unknown as { cluDebug?: object }).cluDebug = {
    enable: enableCluDebug,
    disable: disableCluDebug,
    isEnabled: isCluDebugEnabled,
  };
}
